<div class="gd-article-list__empty" [class.--media]="isMedia" [class.--tree]="!isTable">
  {{ message }}
</div>
